<template>
  <circle pid="0" cx="13" cy="21" r="3"/><circle pid="1" cx="13" cy="5" r="3"/><circle pid="2" cx="13" cy="13" r="3"/>
</template>
